// extracted by mini-css-extract-plugin
export default {"slider_ig":"TopSlider__slider_ig--ig-QR37V","button_ig":"TopSlider__button_ig--ig-yXbsN","left_ig":"TopSlider__left_ig--ig-BZtOL","right_ig":"TopSlider__right_ig--ig-rCXhU"};